import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useI18n } from '@/i18n/i18n-provider';
import { growthApi } from '@/services/growth.api';
import { EmptyState, Spinner } from '@/components/ui';

/** How many people currently sit at each step of the discipleship path —
 *  the shape of the whole congregation's progress, not a roster. */
export function GrowthReportPage() {
  const { t } = useI18n();

  const query = useQuery({
    queryKey: ['growth', 'report'],
    queryFn: () => growthApi.report(),
  });

  const entries = query.data ?? [];
  const maxCount = Math.max(1, ...entries.map((entry) => entry.personCount));

  return (
    <div className="page">
      <Link to="/people/growth/steps" className="back-link">
        {t('common.actions.back')}
      </Link>

      <header className="page-header">
        <div>
          <h1 className="page-title">{t('people.growth.reportTitle')}</h1>
        </div>
      </header>

      {query.isPending && <Spinner label={t('common.states.loading')} />}
      {query.isSuccess && entries.length === 0 && (
        <EmptyState title={t('people.growth.stepsEmpty')} />
      )}

      {entries.length > 0 && (
        <ul className="growth-report-list">
          {entries.map((entry) => (
            <li key={entry.step.id} className="growth-report-row">
              <span className="growth-report-label">{entry.step.name}</span>
              <div className="growth-report-bar-track">
                <div
                  className="growth-report-bar"
                  style={{ inlineSize: `${(entry.personCount / maxCount) * 100}%` }}
                />
              </div>
              <span className="growth-report-count" dir="ltr">
                {entry.personCount}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
